import { render, staticRenderFns } from "./DialogEditarNodo.vue?vue&type=template&id=675f2ce8"
import script from "./DialogEditarNodo.vue?vue&type=script&lang=js"
export * from "./DialogEditarNodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports